import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink, Link } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";
import { type } from "@testing-library/user-event/dist/type";

const API_URL = "/api";

export default function Payments() {
  const { id } = useParams();
  console.log("🔎 Route id:", id);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checklistFormData, setChecklistFormData] = useState([]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getTransactionDetails/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("📥 Full API Response:", data);
        setTransactionData(data);
        console.log("transactionData:", transactionData);
        // setFormData(data?.DocumentCheckList || {});
        setFormData(data); // keep full object for Loan Info
        setCompany(data);
        console.log("Data:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData(transactionData);
    setChecklistFormData(transactionData?.DocumentCheckList || []);
    setIsEditing(false);
  };

  const renderStatusCell = (section) => {
    let value = formData?.[section]?.STATUS || "";
    if (section === "ENTEREXPIRYDATE") value = "";
    return isEditing ? (
      <select
        className="form-select"
        value={value}
        onChange={(e) => handleChange(e, section, "STATUS")}
      >
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="N/A">N/A</option>
      </select>
    ) : (
      <div
        style={{
          backgroundColor: value === "Yes" ? "#58a65c" : "#fdf3d0",
          color: value === "Yes" ? "#fff" : "#000",
          textAlign: "center",
        }}
      >
        {value || ""}
      </div>
    );
  };

  const criteriaLabels = {
    COMPANYNAMEISCORRECT: "Company name is correct",
    THEREGISTRATIONISCURRENT: "The registration is current",
    THERETURNCOVERSTHEMOSTRECENTPERIOD:
      "The return covers the most recent period",
    SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED:
      "Shareholder(s) match organization chart (if provided)",
    THECHARTISSIGNEDANDDATED: "The chart is signed and dated",
    STATEMENTSARESIGNEDBYAUDITOR: "Statements are signed by auditor",
  };

  const renderCheckCell = (section) => {
    // if (section === "SUBMITTEDBUSINESSREGISTRATION") return "";

    // Show the label for these fields instead of CHECKINGDETAILS
    if (
      section === "COMPANYNAMEISCORRECT" ||
      section === "THEREGISTRATIONISCURRENT" ||
      section === "THERETURNCOVERSTHEMOSTRECENTPERIOD" ||
      section === "SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED" ||
      section === "THECHARTISSIGNEDANDDATED" ||
      section === "STATEMENTSARESIGNEDBYAUDITOR"
    ) {
      return criteriaLabels[section] || "";
    }

    if (section === "ENTEREXPIRYDATE") {
      const rawDate = formData?.ENTEREXPIRYDATE?.CHECKINGDETAILS;
      return rawDate ? formatDate(rawDate) : "";
    }

    return formData?.[section]?.CHECKINGDETAILS || "";
  };

  const handleInputChange = (sectionKey, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Utility: format date values into DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid date
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const scoreMapping = {
    "Borrower: A": 20,
    "Borrower: B": 15,
    "Borrower: C": 0,
    "Borrower: D": -10,
  };
  const scoreMappingTransaction = {
    "0% to 10%": 0,
    "11% to 20%": 5,
    "21% to 30%": 8,
    "> 30%": 10,
  };
  const today = new Date();
  const formatted = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long", // 👈 gives full month name
    year: "numeric",
  });
  // const loanAmount = Number(transactionData?.LOANAMOUNT_HK) || 0;
  // const totalFees = Number(transactionData?.TOTALFEES_HK) || 0;

  // const totalLoanPayment =
  //   transactionData?.LOANAMOUNT_HK != null && transactionData?.TOTALFEES_HK != null
  //     ? loanAmount + totalFees
  //     : null;

  // const totalPayment =
  //   totalLoanPayment !== null
  //     ? totalLoanPayment + totalFees
  //     : null;
  // Build repayment rows first
  //const Tranche1 = "";
  const LoanDetails = [
    {
      "Loan Amount (HK$)": "TRANCHE1",
      Amount: transactionData?.TRANCHE1 ?? 0,
      "Maturity Date": "",
      "Interest Rate":
        (
          (transactionData?.PROPOSED_TRANS_TERM?.INTERESTRATE ?? 0) * 100
        ).toFixed(2) + "%",
      "Admin Fee":
        Number(
          (transactionData?.PROPOSED_TRANS_TERM?.ADMINFEE ?? 0) * 100
        ).toFixed(2) + "%",
    },
    {
      "Loan Amount (HK$)": "TRANCHE2",
      Amount: transactionData?.TRANCHE2 ?? 0,
      "Maturity Date": "",
      "Interest Rate":
        (
          (transactionData?.PROPOSED_TRANS_TERM?.INTERESTRATE ?? 0) * 100
        ).toFixed(2) + "%",
      "Admin Fee":
        Number(
          (transactionData?.PROPOSED_TRANS_TERM?.ADMINFEE ?? 0) * 100
        ).toFixed(2) + "%",
    },
  ];

  const enrichedLoanDetails = LoanDetails.map((row) => ({ ...row }));

  // Helper Functions
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return isNaN(d) ? null : d;
  };

  const dateDiffInDays = (start, end) => {
    if (!start || !end) return 0;
    return (end - start) / (1000 * 60 * 60 * 24);
  };

  // Base Payment Summary
  const PaymentSummary = [
    {
      "Payment #": 1,
      Loan: "Tranche 1",
      "Payment Date": "",
      "Admin Fee Paid": Number(
        (
          (transactionData?.TRANCHE1 ?? 0) *
          (transactionData?.PROPOSED_TRANS_TERM?.ADMINFEE ?? 0)
        ).toFixed(2)
      ),
      "Interest Period Start Date": "",
      "Interest Paid": 0,
      "Principal Repayment": 0,
      "Payment Amount": 0,
      "Loan Balance": Number(transactionData?.TRANCHE1 ?? 0),
    },
    {
      "Payment #": 2,
      Loan: "Tranche 2",
      "Payment Date": "",
      "Admin Fee Paid": Number(
        (
          (transactionData?.TRANCHE2 ?? 0) *
          (transactionData?.PROPOSED_TRANS_TERM?.ADMINFEE ?? 0)
        ).toFixed(2)
      ),
      "Interest Period Start Date": "",
      "Interest Paid": 0,
      "Principal Repayment": 0,
      "Payment Amount": 0,
      "Loan Balance": Number(transactionData?.TRANCHE2 ?? 0),
    },
  ];

  // Main Calculation Logic
  const interestRate =
    parseFloat(transactionData?.PROPOSED_TRANS_TERM?.INTERESTRATE) || 0;

  const enrichedPaymentSummary = PaymentSummary.map((row) => {
    const startDate = parseDate(row["Interest Period Start Date"]);
    const endDate = parseDate(row["Payment Date"]);
    const daysDiff = dateDiffInDays(startDate, endDate);

    // Calculate interest only if valid daysDiff
    const interestPaid =
      daysDiff > 0
        ? ((row["Loan Balance"] * interestRate * daysDiff) / 365).toFixed(2)
        : (0).toFixed(2);

    const adminFee = parseFloat(row["Admin Fee Paid"]) || 0;
    const principalRepay = parseFloat(row["Principal Repayment"]) || 0;
    const paymentAmount =
      parseFloat(adminFee) +
      parseFloat(interestPaid) +
      parseFloat(principalRepay);

    return {
      ...row,
      "Interest Paid": interestPaid,
      "Payment Amount": paymentAmount.toFixed(2),
    };
  });

  // Totals Row
  const totals = enrichedPaymentSummary.reduce(
    (acc, row) => {
      acc["Payment Amount"] += Number(row["Payment Amount"]);
      acc["Admin Fee Paid"] += Number(row["Admin Fee Paid"]);
      acc["Interest Paid"] += Number(row["Interest Paid"]);
      acc["Principal Repayment"] += Number(row["Principal Repayment"]);
      acc["Loan Balance"] += Number(row["Loan Balance"]);
      return acc;
    },
    {
      "Payment Amount": 0,
      "Admin Fee Paid": 0,
      "Interest Paid": 0,
      "Principal Repayment": 0,
      "Loan Balance": 0,
    }
  );

  // Now safely calculate sums

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Transaction List
            </NavLink>

            <br />
            <br />
            <NavLink
              to={`/ViewTransactionList/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Loan Details
            </NavLink>

            <NavLink
              to={`/Drawdowns/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Drawdowns
            </NavLink>

            <NavLink
              to={`/ApplicationChecklist/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Application Checklist
            </NavLink>

            <NavLink
              to={`/ScoreCard/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scorecard
            </NavLink>

            <NavLink
              to={`/TransactionSummary/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Transaction Summary
            </NavLink>

            <NavLink
              to={`/TermSheet/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Term Sheet
            </NavLink>

            <NavLink to={`/Payments/${id}`} className="btn btn-dark ms-2">
              Payments
            </NavLink>
            <NavLink
              to={`/RepaymentAndInterest/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Repayment & Interest(Term)
            </NavLink>

            <NavLink
              to={`/InterestCalculations/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Interest Calculations
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Payments</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData(transactionData);
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !transactionData ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <div className="row">
                  <div className="col-md-8">
                    <table>
                      <tbody>
                        <tr>
                          <td>From:</td>
                          <td style={{ paddingLeft: "40px" }}>
                            River Square Company Limited (the “Lender”)
                          </td>
                        </tr>
                        <tr>
                          <td>{transactionData?.BORROWER_LABEL || "To"}</td>
                          <td style={{ paddingLeft: "40px" }}>
                            {transactionData?.BORROWER || "N/A"}
                          </td>
                        </tr>
                        <br></br>
                        <tr>
                          <td>{transactionData?.DATE_LABEL || "Date"}</td>
                          <td style={{ color: "red", paddingLeft: "40px" }}>
                            {formatted}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-4 d-flex justify-content-end align-items-center">
                    <img
                      src="/Logo2.png"
                      alt="Riverchain"
                      style={{ maxWidth: "240px", height: "100px" }}
                    />
                  </div>
                </div>
                <br></br>
                <p>
                  <h2 style={{ textAlign: "center" }}>
                    Loan Balance Statement
                  </h2>
                </p>
                <br></br>
                <div className="col-md-12">
                  <table>
                    <tbody>
                      <tr>
                        <td>{transactionData?.BORROWER_LABEL || "To"}</td>
                        <td style={{ paddingLeft: "40px" }}>
                          {transactionData?.BORROWER || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.TRANSACTIONID_LABEL ||
                            "Transaction ID"}
                        </td>
                        <td style={{ paddingLeft: "40px" }}>
                          {transactionData?.TRANSACTIONID || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br></br>
                  <table>
                    <thead>
                      <tr style={{ borderBlock: "2px solid black" }}>
                        <th colSpan={"4"}>Loan Details </th>
                      </tr>
                      <tr style={{ borderBlock: "2px solid black" }}>
                        <th>Loan Amount (HK$) </th>
                        <th style={{ paddingLeft: "40px" }}>Maturity Date</th>
                        <th style={{ paddingLeft: "40px" }}>Interest Rate</th>
                        <th style={{ paddingLeft: "40px" }}>Admin Fee</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "right" }}>
                      {enrichedLoanDetails.map((row, idx) => (
                        <tr key={idx}>
                          <td>
                            {row["Loan Amount (HK$)"]} : {row.Amount ?? 0}
                          </td>
                          <td>{row["Maturity Date"]}</td>
                          <td>{row["Interest Rate"]}</td>
                          <td>{row["Admin Fee"]}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ borderBlock: "2px solid black" }}>
                      <tr>
                        <td>Total</td>
                        <td>{transactionData?.LOANAMOUNT_HK || "N/A"}</td>
                      </tr>
                    </tfoot>
                  </table>
                  <br></br>
                  <table
                    className="table table-bordered"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#173660",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        <th colSpan="9" style={{ textAlign: "center" }}>
                          Payment Summary
                        </th>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#f2f2f2",
                          fontWeight: "bold",
                        }}
                      >
                        <th>Payment #</th>
                        <th>Loan</th>
                        <th>Payment Date</th>
                        <th>Payment Amount</th>
                        <th>Admin Fee Paid</th>
                        <th>Interest Period Start Date</th>
                        <th>Interest Paid</th>
                        <th>Principal Repayment</th>
                        <th>Loan Balance</th>
                      </tr>
                    </thead>

                    <tbody>
                      {enrichedPaymentSummary.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row["Payment #"]}</td>
                          <td>{row["Loan"]}</td>
                          <td>{row["Payment Date"] || "-"}</td>
                          <td>{Number(row["Payment Amount"]).toFixed(2)}</td>
                          <td>{Number(row["Admin Fee Paid"]).toFixed(2)}</td>
                          <td>{row["Interest Period Start Date"] || "-"}</td>
                          <td>{Number(row["Interest Paid"]).toFixed(2)}</td>
                          <td>
                            {Number(row["Principal Repayment"]).toFixed(2)}
                          </td>
                          <td>{Number(row["Loan Balance"]).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot
                      style={{ fontWeight: "bold", backgroundColor: "#f8f8f8" }}
                    >
                      <tr>
                        <td>Total</td>
                        <td></td>
                        <td></td>
                        <td>{totals["Payment Amount"].toFixed(2)}</td>
                        <td>{totals["Admin Fee Paid"].toFixed(2)}</td>
                        <td></td>
                        <td>{totals["Interest Paid"].toFixed(2)}</td>
                        <td>{totals["Principal Repayment"].toFixed(2)}</td>
                        <td>{totals["Loan Balance"].toFixed(2)}</td>
                      </tr>
                    </tfoot>
                  </table>

                  <br></br>
                  <br></br>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
